import styled from 'styled-components';

import { ModalContent } from 'components/modal';

export const Content = styled(ModalContent)`
  > div {
    justify-content: space-between;
    padding-block-end: 2rem;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 280px;

  ${Styles.desktop} {
    max-width: 500px;
  }
`;

export const P = styled.p`
  text-align: center;
`;
